import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Multiple } from '../../../../components/multiple-text-blurb-for-grid';
import messages from '../../messages';

const name = <FormattedMessage {...messages.connectionNameColumnHeader} />;

/**
 * Component to display the connection name
 * @param {object} props
 * @param {string} [props.connectionName] - The connection name
 * @returns {string} Connection name or empty string
 */
const ConnectionName = ({ connectionName }) => {
  return connectionName ?? '';
};

export const connectionNameColumn = {
  getMessageDescriptor: () => messages.connectionNameColumnHeader,
  name,
  render: (data, { isExpanded = false, isFirstRow = true, allData = [] }) => {
    const uniqueConnectionNames = new Set(Array.isArray(allData) ? allData.map((item) => item?.connectionName) : [allData?.connectionName]);

    const shouldShowMultipleLabel = !isExpanded && isFirstRow && uniqueConnectionNames.size > 1;
    if (shouldShowMultipleLabel) {
      return <Multiple />;
    }
    return <ConnectionName connectionName={data?.connectionName} />;
  },
};
